import { rankWith, isNumberControl } from '@jsonforms/core';

export default rankWith(3, isNumberControl);
